import classNames from 'classnames'
import { OverlayTrigger, Popover } from 'react-bootstrap'

import { selectDocumentBatchDocuments } from '../../../store/processDocument/documentBatch'
import { useAppSelector } from '../../../store/hooks'

import styles from './DocumentBatchChatHeader.module.scss'

export const DocumentBatchChatHeader = () => {
  const batchDocuments = useAppSelector(selectDocumentBatchDocuments)

  const popover = (
    <Popover id='document-batch-chat-header-popover' className='border-0 shadow'>
      <Popover.Body className='d-flex flex-column zocks-gap-0.75 zocks-p-0.75'>
        <span className='paragraph-small zocks-text-gray-600'>Answers use these documents</span>
        <ul className={classNames('list-unstyled d-flex flex-column zocks-gap-0.5 m-0 overflow-auto', styles.documentList)}>
          {batchDocuments.map((document) => (
            <li key={document.id} className='paragraph-small text-truncate flex-shrink-0'>
              {document.name}
            </li>
          ))}
        </ul>
      </Popover.Body>
    </Popover>
  )

  return (
    <div className='ms-auto'>
      <OverlayTrigger trigger='click' rootClose placement='bottom-end' overlay={popover}>
        <button
          type='button'
          className='d-flex align-items-center zocks-gap-0.25 zocks-py-0.25 px-2 border-0 zocks-border-0.25 zocks-bg-color-gray-200 paragraph-small text-nowrap'
        >
          Reads {batchDocuments.length} {batchDocuments.length === 1 ? 'document' : 'documents'}
          <i className='bi bi-question-circle' />
        </button>
      </OverlayTrigger>
    </div>
  )
}
